import { hasAnyAccessToResource } from "api/general";
import { Subheader } from "components/Header/Subheader/Subheader";
import { TopHeader } from "components/Header/TopHeader/TopHeader";
import { OLTabs } from "components/Tabs/OLTabs";
import { useMessage } from "hooks/intl";
import { useActiveTab } from "hooks/useActiveTab";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { links } from "utilities/links";
import { ActionsList } from "../Actions/ActionsList";
import { ExportsList } from "../Export/ExportsList";
import { ImportsList } from "../Import/ImportsList";

export enum Modals {
  ImportAddingUnitsTransfers,
  ImportSpendingUnitsTransfers,
}

export const ImportsExports = () => {
  const { message } = useMessage();
  const { state } = useLocation();

  const hasAnyImportPermission = hasAnyAccessToResource("IMPORT");
  const hasAnyExportPermission = hasAnyAccessToResource("EXPORT");

  const tabLabels = {
    ...(hasAnyImportPermission && {
      imports: "imports",
    }),
    ...(hasAnyExportPermission && {
      exports: "exports",
    }),
    massActionsLog: "massActionsLog",
  } as const;

  const tabsList = Object.keys(tabLabels) as string[];

  const initialActiveTabState = state?.activeTab || tabLabels.imports;

  const { activeTab, changeActiveTab } = useActiveTab({
    id: "importsExports",
    tab: !hasAnyImportPermission
      ? tabLabels.exports
      : !hasAnyExportPermission
        ? tabLabels.imports
        : initialActiveTabState,
  });

  useEffect(() => {
    if (state && state.activeTab) {
      changeActiveTab(links.importsExports, "importsExports", state.activeTab);
    }
  }, [state, changeActiveTab]);

  return (
    <>
      <TopHeader title={message({ id: "importsExports" })} />
      <Subheader>
        <OLTabs
          items={tabsList}
          value={activeTab}
          onChange={(_: React.SyntheticEvent, newValue: string) =>
            changeActiveTab(links.importsExports, "importsExports", newValue)
          }
        />
      </Subheader>
      {activeTab === tabLabels.imports && (
        <ImportsList activeTab={activeTab} tabLabels={tabLabels} />
      )}
      {activeTab === tabLabels.exports && <ExportsList />}
      {activeTab === tabLabels.massActionsLog && <ActionsList />}
    </>
  );
};
